import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/hooks/useLanguage";
import JsonLd from "@/components/feature/JsonLd";
import { buildWebSiteSchema, buildFaqPageSchema } from "@/constants/schema";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import CategoryGrid from "./components/CategoryGrid";
import InfoSections from "./components/InfoSections";
import ArticlesSection from "./components/ArticlesSection";
import ClosingSections from "./components/ClosingSections";

interface FaqItem {
  q: string;
  a: string;
}

export default function Home() {
  const { lang } = useParams();
  const currentLang = useLanguage(lang);

  const { t } = useTranslation();
  const location = useLocation();

  const faqItems = t("faq.items", { returnObjects: true }) as FaqItem[];

  useEffect(() => {
    if (location.hash === "#guides") {
      requestAnimationFrame(() => {
        document.getElementById("guides")?.scrollIntoView({ behavior: "smooth" });
      });
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={buildWebSiteSchema(currentLang, t("hero.subtitle"))} />
      <JsonLd data={buildFaqPageSchema(faqItems)} />
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <InfoSections />
        <ArticlesSection />
        <ClosingSections />
      </main>
      <Footer />
    </div>
  );
}